var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H17C17.9711 19 18.599 18.9977 19.0615 18.9355C19.4951 18.8772 19.6309 18.7831 19.707 18.707C19.7831 18.6309 19.8772 18.4951 19.9355 18.0615C19.9977 17.599 20 16.9711 20 16V8H4V16C4 16.9711 4.00227 17.599 4.06445 18.0615C4.12277 18.4951 4.21686 18.6309 4.29297 18.707C4.36908 18.7831 4.50493 18.8772 4.93848 18.9355C5.40098 18.9977 6.02892 19 7 19Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 8C21.2535 8 22 7.25348 22 6.33301C21.9998 5.0446 20.9554 4.00018 19.667 4H4.33301C3.0446 4.00018 2.00018 5.0446 2 6.33301C2 7.25348 2.74652 8 3.66699 8H20.333Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.7559005d90dd35191984c09e3be93969.svg";
export { ForwardRef as ReactComponent };